import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSwapAB = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		strokeLinecap: "round",
		strokeWidth: 1.5,
		stroke: "currentColor",
		fill: "none",
		strokeLinejoin: "round",
		children: [
			/* @__PURE__ */ _jsx("path", { d: "M6,6l2,-2l-2,-2" }),
			/* @__PURE__ */ _jsx("path", { d: "M10.8891,12.6109c2.14788,2.14788 2.14788,5.63029 0,7.77817c-2.14788,2.14788 -5.63029,2.14788 -7.77817,0c-2.14788,-2.14788 -2.14788,-5.63029 -1.33227e-15,-7.77817c2.14788,-2.14788 5.63029,-2.14788 7.77817,-1.77636e-15" }),
			/* @__PURE__ */ _jsx("path", { d: "M9.475,18.552l-2.475,-4.95l-2.475,4.95" }),
			/* @__PURE__ */ _jsx("path", { d: "M5.02,17.56h3.96" }),
			/* @__PURE__ */ _jsx("path", { d: "M20.8891,3.61091c2.14788,2.14788 2.14788,5.63029 0,7.77817c-2.14788,2.14788 -5.63029,2.14788 -7.77817,0c-2.14788,-2.14788 -2.14788,-5.63029 -1.77636e-15,-7.77817c2.14788,-2.14788 5.63029,-2.14788 7.77817,-1.33227e-15" }),
			/* @__PURE__ */ _jsx("path", { d: "M15,7.5v-1.975c0,-0.276 0.224,-0.5 0.5,-0.5h2.312c0.683,0 1.238,0.554 1.238,1.237v0c0,0.683 -0.554,1.237 -1.238,1.237h-2.812Z" }),
			/* @__PURE__ */ _jsx("path", { d: "M15,7.5v1.975c0,0.276 0.224,0.5 0.5,0.5h2.55c0.683,0 1.237,-0.554 1.237,-1.237v0c0,-0.683 -0.554,-1.237 -1.237,-1.237" }),
			/* @__PURE__ */ _jsx("path", { d: "M18,18l-2,2l2,2" }),
			/* @__PURE__ */ _jsx("path", { d: "M21,16v2c0,1.105 -0.895,2 -2,2h-3" }),
			/* @__PURE__ */ _jsx("path", { d: "M3,8v-2c0,-1.105 0.895,-2 2,-2h3" })
		]
	}), /* @__PURE__ */ _jsx("path", {
		fill: "none",
		d: "M0,0h24v24h-24Z"
	})]
});
export default SvgSwapAB;
